"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../constants");
var es_1 = __importDefault(require("./locales/es"));
var it_1 = __importDefault(require("./locales/it"));
var configuration = (_a = {},
    _a[constants_1.DEFAULT_LOCALE] = es_1.default,
    _a['it-IT'] = it_1.default,
    _a);
exports.default = configuration;
